import React from 'react'
import {Box,chakra,HStack,Text} from '@chakra-ui/react'
import { useIntl } from 'react-intl'
import { ECOMMERCE_MESSAGES } from '../../intl/messages'

export const HorizontalPaymentInformation = chakra(({className})=>{
    const intl = useIntl()

    return(
        <Box  className={className}  py="30px" color='white' px={8} bgGradient="linear(to-r,lilaPurple.dark 0%,tealBlue.light 60%)" w='100%' as='section' >
        <HStack spacing={5} justifyContent='space-between' mx='auto' maxW='container.xl'>
        <Text as='h3' fontSize='600'>
          {intl.formatMessage(ECOMMERCE_MESSAGES.cheapinternationaldeliver)}
        </Text>
        <Text as='h3' fontSize='600'>
        {intl.formatMessage(ECOMMERCE_MESSAGES.moneyback)}
        </Text>
        <Text as='h3' fontSize='600'>
        {intl.formatMessage(ECOMMERCE_MESSAGES.securepaymentswith)}
        </Text>
        </HStack>
      </Box>
    )

})